import { useState } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { Plus } from 'lucide-react'
import { RouteErrorFallback } from '@/components/ErrorBoundary'
import {
  PageCard,
  PageContainer,
  PageContent,
  PageHeader,
  PageHeaderContent,
  PageHeaderDescription,
  PageHeaderHeading,
  PageHeaderTitle,
} from '@/components/ui/page'
import { Button } from '@/components/ui/button'
import { VoicesTable } from '@/components/admin/voices/VoicesTable'
import { VoiceFormSheet } from '@/components/admin/voices/VoiceFormSheet'
import { useVoices, type Voice } from '@/hooks/useVoices'

export const Route = createFileRoute('/admin/voices/')({
  component: VoicesAdmin,
  errorComponent: RouteErrorFallback,
})

function VoicesAdmin() {
  const [formOpen, setFormOpen] = useState(false)
  const [editingVoice, setEditingVoice] = useState<Voice | null>(null)
  // Same query the table uses — react-query serves both from one request.
  const { data: voices } = useVoices(false)

  const inactiveCount = (voices ?? []).filter((voice) => !voice.is_active).length
  const countSuffix = voices
    ? ` · ${voices.length} ${voices.length === 1 ? 'Stimme' : 'Stimmen'}${
        inactiveCount > 0 ? `, ${inactiveCount} inaktiv` : ''
      }`
    : ''

  const openCreate = () => {
    setEditingVoice(null)
    setFormOpen(true)
  }

  const openEdit = (voice: Voice) => {
    setEditingVoice(voice)
    setFormOpen(true)
  }

  return (
    <>
      <PageContainer>
        <PageCard>
          <PageHeader>
            <PageHeaderContent>
              <PageHeaderTitle>
                <PageHeaderHeading>Stimmen</PageHeaderHeading>
                <PageHeaderDescription>
                  Globaler Stimmenkatalog für alle Agenten{countSuffix}
                </PageHeaderDescription>
              </PageHeaderTitle>
              <Button size="sm" onClick={openCreate}>
                <Plus className="mr-1 h-4 w-4" />
                Neue Stimme
              </Button>
            </PageHeaderContent>
          </PageHeader>
          <PageContent className="p-4">
            <VoicesTable className="flex-1 min-h-0" onEdit={openEdit} />
          </PageContent>
        </PageCard>
      </PageContainer>

      <VoiceFormSheet open={formOpen} onOpenChange={setFormOpen} voice={editingVoice} />
    </>
  )
}
